import { render, staticRenderFns } from "./CartFloatingButton.vue?vue&type=template&id=bf25fe0a"
import script from "./CartFloatingButton.vue?vue&type=script&lang=js"
export * from "./CartFloatingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports